import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Inner = styled.header.withConfig({
  displayName: "Inner",
  componentId: "sc-y626vg-0"
})(["display:block;"]);
export var InnerWrapper = styled.div.withConfig({
  displayName: "Inner__InnerWrapper",
  componentId: "sc-y626vg-1"
})(["display:flex;margin-bottom:24px;", ";"], maxMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    overflow-x: hidden;\n    flex-wrap: wrap;\n    // gap\n\n    > div {\n      overflow-x: scroll;\n    }\n\n    > div:not(:first-child) {\n      margin-top: 16px;\n    }\n  "]))));